import { createContext, useEffect, useState, useRef } from 'react';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { Typography, Alert, Box, Button, CircularProgress } from '@mui/material';
import { Check } from 'react-feather';

// Context for queue state
export const QueueContext = createContext({
  working: false
});

export const QueueProvider = ({ children }) => {
  const [working, setWorking] = useState(false);
  const [showReloadButton, setShowReloadButton] = useState(false);
  const [currentJob, setCurrentJob] = useState(null);

  const echoRef = useRef(null);

  useEffect(() => {
    window.Pusher = Pusher;

    echoRef.current = new Echo({
      broadcaster: 'pusher',
      key: process.env.REACT_APP_PUSHER_APP_KEY,
      cluster: process.env.REACT_APP_PUSHER_APP_CLUSTER ?? 'eu',
      forceTLS: true
    });

    echoRef.current.channel('jobs').listen('.JobProgressUpdated', (data) => {
      setCurrentJob(data);

      if (data.status === 'started') {
        setWorking(true);
        setShowReloadButton(false);
      }
      if (data.status === 'finished') {
        setWorking(false);
        setShowReloadButton(true);
      }
    });

    return () => {
      echoRef.current.disconnect();
    };
  }, []);

  useEffect(() => {
    if (showReloadButton) {
      const timeout = setTimeout(() => {
        setShowReloadButton(false);
      }, 10000);
      return () => clearTimeout(timeout);
    }
  }, [showReloadButton]);

  return (
    <QueueContext.Provider value={{ working }}>
      {children}

      {showReloadButton && (
        <Box
          sx={{
            position: 'absolute',
            bottom: 20,
            right: 20,
            zIndex: 9999
          }}
        >
          <Alert sx={{ display: 'flex', alignItems: 'center' }} icon={<Check size={20} />} onClose={() => setShowReloadButton(false)}>
            <Typography variant="body1" sx={{ marginRight: '4px', fontSize: '15px' }} display="inline">
              {currentJob?.message}
            </Typography>
            <Button color="inherit" size="small" sx={{ paddingTop: 0, paddingBottom: 0 }} onClick={() => window.location.reload()}>
              ENDURHLAÐA
            </Button>
          </Alert>
        </Box>
      )}

      {working && (
        <Box
          sx={{
            position: 'absolute',
            bottom: 20,
            right: 20,
            zIndex: 9999
          }}
        >
          <Alert sx={{ display: 'flex', alignItems: 'center' }} icon={<CircularProgress color="success" size={20} />}>
            <Typography variant="body1" sx={{ marginRight: '4px', fontSize: '15px' }} display="inline">
              {currentJob?.message}
            </Typography>
          </Alert>
        </Box>
      )}
    </QueueContext.Provider>
  );
};
